let activeLocks = 0;
let scrollX = 0;
let scrollY = 0;

/** Lock document scrolling until the last modal closes, sizing each to the visual viewport. */
export function lockModalViewport(dialog: HTMLElement): () => void {
  const viewport = window.visualViewport;
  if (activeLocks++ === 0) {
    scrollX = window.scrollX;
    scrollY = window.scrollY;
    document.body.style.setProperty('--modal-scroll-top', `${-scrollY}px`);
    document.body.classList.add('modal-open');
  }

  const update = (): void => {
    dialog.style.setProperty('--modal-viewport-top', `${viewport?.offsetTop ?? 0}px`);
    dialog.style.setProperty('--modal-viewport-height', `${viewport?.height ?? window.innerHeight}px`);
  };
  update();
  viewport?.addEventListener('resize', update);
  viewport?.addEventListener('scroll', update);
  window.addEventListener('resize', update);

  let released = false;
  return () => {
    if (released) return;
    released = true;
    viewport?.removeEventListener('resize', update);
    viewport?.removeEventListener('scroll', update);
    window.removeEventListener('resize', update);
    dialog.style.removeProperty('--modal-viewport-top');
    dialog.style.removeProperty('--modal-viewport-height');
    if (--activeLocks === 0) {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('--modal-scroll-top');
      window.scrollTo(scrollX, scrollY);
    }
  };
}
